import Velocity from "velocity-animate";
import LayoutLanding from "@/layouts/LayoutLanding/LayoutLanding.vue";
import SearchBox from "@/components/Search/SearchBox/SearchBox.vue";
import BrowsePanel from "@/components/BrowseByIndexPanel/BrowsePanel/BrowsePanel.vue";
import { sentencesIndexItems } from "@/common/navigation";
import { isSmallDevice } from "@/common/functions";
import Advertising from "@/components/Advertising/Advertising.vue";

export default {
    components: {
        LayoutLanding,
        SearchBox,
        BrowsePanel,
        Advertising
    },
    data() {
        return {
            layout: LayoutLanding,
            sentencesIndexItems,
            showMore: false,
            nojs: document.documentElement.className === "no-js"
        };
    },
    computed: {
        preliminaryDescriptionText() {
            return this.$t("thesaurusLandingBody").split("<br>")[0];
        },
        expandedDescriptionText() {
            let text =
                "<br>" +
                this.$t("thesaurusLandingBody")
                    .split("<br>")
                    .slice(1)
                    .join("<br>");
            return text;
        },
        showMoreTranslation() {
            return {
                text: this.showMore ? this.$t("showlessThesaurus") : this.$t("showmoreThesaurus"),
                title: this.showMore
                    ? this.$t("showlessThesaurusTitle")
                    : this.$t("showmoreThesaurusTitle")
            };
        }
    },
    methods: {
        isSmallDevice,
        beforeFadeInEnter(el) {
            el.style.opacity = 0;
        },
        fadeIn(el, done) {
            Velocity(el, { opacity: "1" }, { duration: 500, complete: done });
        },
        fadeOut(el, done) {
            Velocity(el, { opacity: "0" }, { duration: 250, complete: done });
        }
    },
    metaInfo() {
        return {
            title: this.$t(`thesaurusLandingPageMetaTitle`),
            meta: [
                {
                    name: "description",
                    content: this.$t(`thesaurusLandingPageMetaDescription`)
                },
                {
                    name: "keywords",
                    content: this.$t(`thesaurusLandingPageMetaKeywords`)
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `https://thesaurus.yourdictionary.com/`
                }
            ]
        };
    },
    created() {
        this.$emit("update:layout", LayoutLanding);
    },
    mounted() {
        if (typeof window.__PRERENDER_INJECTED !== "undefined")
            setTimeout(() => {
                window.document.dispatchEvent(new CustomEvent("spa-render-complete"));
            }, 200);
    }
};



// WEBPACK FOOTER //
// ./src/pages/Synonyms/Home/SynonymsHome.js